import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("apex_admin_token", data.access_token);
      localStorage.setItem("apex_admin_email", data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-secondary/30 px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md card-apex p-10">
        <div className="flex justify-center"><Logo size={48} /></div>
        <div className="mt-8 text-center">
          <div className="overline">Admin</div>
          <h1 className="heading-display text-3xl mt-3">Sign in</h1>
          <p className="mt-2 text-sm text-muted-foreground">Manage leads, bookings, and content.</p>
        </div>
        <div className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-2 block">Email</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full bg-background border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-[#16A34A] focus:ring-2 focus:ring-[#16A34A]/30"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-2 block">Password</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full bg-background border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-[#16A34A] focus:ring-2 focus:ring-[#16A34A]/30"
            />
          </div>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full justify-center mt-8">
          <Lock size={14} /> {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
